import { Prize } from '../types'

export type PrizesActionType = 'SET_PRIZES' | 'SET_SELECT_PRIZE' | 'SET_ERROR' | 'SET_CONGRATS'

export interface PrizesState {
  prizes?: Prize[]
  selectPrize?: Prize
  error?: number
  congrats?: boolean
}

export interface PrizesAction {
  type: PrizesActionType
  payload: PrizesState | Prize[] | Prize | number  | boolean
}

function prizesReducer(state: PrizesState, action: PrizesAction): PrizesState {
  switch (action.type) {
  case 'SET_PRIZES':
    return { ...state, prizes: action.payload as Prize[] }
  case 'SET_SELECT_PRIZE':
    return { ...state, selectPrize: action.payload as Prize }
  case 'SET_CONGRATS':
    return { ...state, congrats: action.payload as boolean }  
  case 'SET_ERROR':
    return { ...state, error: action.payload as number }  
  default:
    return state
  }
}

export default prizesReducer